import React, { FC } from 'react'
import './style.scss'

interface ComponentProps {
	children: string | JSX.Element | JSX.Element[] | (string | JSX.Element)[]
}

export const FooterComponent: FC<ComponentProps> = ({ children }) => {
	return (
		<div id="blockFooter" className="landing-credits_footer">
			<p className="landing-credits_text">{children}</p>
		</div>
	)
}
